import appSettings from 'wanderu-config';

import ClientGoogleService from './ClientGoogleService';
import GoogleOneTapService from './GoogleOneTapService';
import ServerGoogleService from './ServerGoogleService';

function getTargetGoogleService() {
    return appSettings.env.isClient
        ? ClientGoogleService
        : ServerGoogleService;
}

function getLoggedInUser() {
    return getTargetGoogleService().getLoggedInUser();
}

function getLoggedInState() {
    return getTargetGoogleService().getLoggedInState();
}

function logOut() {
    return getTargetGoogleService().logOut();
}

function logIn(token) {
    return getTargetGoogleService().logIn(token);
}

const GoogleButtonService = {
    getLoggedInState,
    getLoggedInUser,
    logIn,
    logOut,
};

export {
    GoogleButtonService,
    GoogleOneTapService,
};
